<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}

.menu-dragbox .vs-list--item {
  background: #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
}

.menu-dragbox {
  height: 340px;
  overflow-y: scroll;
}

.vs-list--item {
  position: relative;
}
/*.vs-input-primary {
  position: absolute;
  left: 4px;
  top: 0;
}*/
.menu-editwrap span:first-child {
  display: inline-flex;
  height: 100%;
  background: transparent;
  margin-left: 10px;
  color: #fff;
  padding: 4px 14px;
  margin-top: 0;
  border-radius: 3px;
}
.menu-editwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Floor Maps</h3>
      <div class="knowlg-base-wrap-sec">
        <!-- <a href="/pages/knowledge-base/category-pages/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span> Need help with this section?
        </a> -->
      </div>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ pageData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : pageData.length }} of {{ pageData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD -->
        <vs-button type="gradient mr-4" v-on:click="$router.push(`/event/venues`)">Venue</vs-button>
        <vs-button type="gradient mr-4" v-on:click="addRecord ()">Add Floor Map</vs-button>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <!-- <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>InActive</span>
              </span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"          
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="pageData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

// Store Module
import moduleFloorMapManagement from "@/store/floormap-management/moduleFloorMapManagement.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererMap from "./cell-renderer/CellRendererMap.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

//console.log(db);

export default {
  components: {
    AgGridVue,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererMap,
    CellRendererActions,
  },
  data() {
    return {    
      searchQuery: "",  
      gridOptions: {},
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'ID',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Title",
          field: "Name",
          filter: true,
          width: 300,
          //cellRendererFramework: "CellRendererLink",
          //pinned: "left",
        },                
        {
          headerName: 'Image',
          field: 'transactions',
          //width: 125,
          cellRendererFramework: 'CellRendererLink',
          cellRendererParams: (params) => {
            return { id: params.data.ID };
          },
          cellClass: 'text-center'
        },
        {
          headerName: 'Venue',
          field: 'Venue',
          filter: true,
          //width: 125,
          cellRenderer: (data) => {
            return data.value && data.value.Name ? data.value.Name : "NA";
          },
        },
        {
          headerName: 'Booth / Route',
          field: 'transactions',
          filter: false,
          //width: 125,
          //cellClass: 'text-center',
          cellRendererFramework: 'CellRendererMap',
          cellRendererParams: (params) => {
            return { id: params.data.ID };
          },
        },        
        {
          headerName: 'Status',
          field: 'transactions',
          filter: false,
          //width: 125,
          cellRendererFramework: 'CellRendererStatus',
        },
        {
          headerName: "Actions",
          field: "transactions",
          //width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.ID };
          },
          pinned: "right",
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererMap,
        CellRendererActions,
      },
    };
  },
  watch: {
  },
  computed: {
    pageData() {
      return this.$store.state.floorMapManagement.floormaps;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    addRecord() {
      this.$router.push(`/event/floormap/add`).catch(() => {});
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleFloorMapManagement.isRegistered) {
      this.$store.registerModule("floorMapManagement", moduleFloorMapManagement);
      moduleFloorMapManagement.isRegistered = true;
    }
    this.$store.dispatch("floorMapManagement/fetchFloorMaps").catch((err) => {
      console.error(err);
    });
  },
};
</script>